import { getAppNames, registerApplication, start } from 'single-spa';
import { constructApplications, constructLayoutEngine, constructRoutes } from 'single-spa-layout';
import { configureAuthAndLayout } from './configureAuthAndLayout';
import { setFeatureFlag } from './utils/setFeatureFlag';
import './root.css';
import { Pendo, DataDog } from './service';
import { isAllowedDomain, sanitizeUrl } from './utils/api';
import { ALLOWED_DOMAINS } from './utils/constants';

// add to avoid can not listen pendoLoad EVENT
var isOneTrustAllowPendo = false;

function loadEMScript(appConfig) {
  if (
    appConfig.messengerConfig &&
    appConfig.messengerConfig.scriptUrl &&
    appConfig.messengerConfig.moduleIdUrl
  ) {
    const hostname = location.hostname;
    if(isAllowedDomain(hostname, ALLOWED_DOMAINS)) {
      const emScript = document.createElement('script');
      emScript.type = 'text/javascript';
      emScript.src = sanitizeUrl(appConfig.messengerConfig.scriptUrl);
      // if (hostname !== 'localhost') {
        document.head.appendChild(emScript);  
      // }
    };
  }
}


(async () => {
  const { layout, applicationId, appConfig } = await configureAuthAndLayout();

  // https://single-spa.js.org/docs/layout-overview#basic-usage
  //Radv2-v3 - add workspace url
  // layout.routes[0].routes = withWorkspacePath(layout.routes[0].routes);
  const routes = constructRoutes(layout);
  const applications = constructApplications({
    routes,
    loadApp: ({ name }) => System.import(name),
  });
  const layoutEngine = constructLayoutEngine({ routes, applications });

  try {
    /* datadog init */
    const dataDog = new DataDog(applicationId);
    dataDog.initialize();

    // MFEs are registered by the application only after auth has been properly configured
    // and is running
    const appNames = getAppNames();

    if (appNames.length === 0) {
      applications.forEach(registerApplication);
      // System.import('@rad/styleguide').then(() => {
      System.import('@nlhr/styleguide'); // add angular appkit style to fix conflict issue
      // });
    }
  } catch (err) {
    console.error("could not load '@rad/auth', '@rad/styleguide' or '@rad/core'", err);
  } finally {
    /* pendo init */
    // eable EM
    loadEMScript(appConfig);
    // load feature config
    setFeatureFlag(appConfig);
    // TBD - pendo
    // if (isOneTrustAllowPendo) {
    //   const userData = EventBus.getEventValue(GlobalEvents.UserData);
    //   const pendo = new Pendo(applicationId, userData);
    //   pendo.initialize();
    // }
    layoutEngine.activate();
    start();
  }
})();

// OneTrust Cookies Consent Notice start for portal.ec.pwc.com
(function () {
  const loadFirstScript = document.createElement('script');
  loadFirstScript.type = 'text/javascript';
  const loadSecondScript = document.createElement('script');
  loadSecondScript.type = 'text/javascript';
  loadSecondScript.charset = 'UTF-8';
  loadSecondScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  loadSecondScript.setAttribute('data-language', 'en');
  // loadSecondScript.setAttribute('integrity', 'sha384-mNABBGQj9vAksZfUmmhJoPXQjELlqQD6h73lwR6O27ytsu9lEtq171nDQxSb6qV5');
  loadSecondScript.setAttribute('crossorigin', 'anonymous');

  const hostname = window.location.hostname;
  if (hostname === 'stage.nlhr.pwc.com') {
    loadFirstScript.src =
      'https://cdn.cookielaw.org/consent/48116486-1d50-44af-87a8-e12ddbceb2d7-test/OtAutoBlock.js';
    // loadFirstScript.setAttribute('integrity', 'sha384-5HBjesEkl5cAGxJdOgEedDNgZt2sJPD8416eIgBM+GROXHVaOkdz6PHnX985Hu7B');
    loadFirstScript.setAttribute('crossorigin', 'anonymous');
    loadSecondScript.setAttribute(
      'data-domain-script',
      '48116486-1d50-44af-87a8-e12ddbceb2d7-test'
    );
  } else if (hostname === 'nextlevelhr.pwc.com') {
    loadFirstScript.src =
      'https://cdn.cookielaw.org/consent/f77c9abc-7714-4e88-99c9-11ae8b668ace/OtAutoBlock.js';
    // loadFirstScript.setAttribute('integrity', 'sha384-5HBjesEkl5cAGxJdOgEedDNgZt2sJPD8416eIgBM+GROXHVaOkdz6PHnX985Hu7B');
    loadFirstScript.setAttribute('crossorigin', 'anonymous');
    loadSecondScript.setAttribute('data-domain-script', 'f77c9abc-7714-4e88-99c9-11ae8b668ace');
  } else {
    loadFirstScript.src =
      'https://cdn.cookielaw.org/consent/8abad26a-eb17-40f2-ba7f-6cd61a75adf7-test/OtAutoBlock.js';
    // loadFirstScript.setAttribute('integrity', 'sha384-4z5AqXLNZa90iZXPVHwJNkQVfDw75HQ86t/40nwde4m8VW8sblIIkeUyLyR+x6d2');
    loadFirstScript.setAttribute('crossorigin', 'anonymous');
    loadSecondScript.setAttribute(
      'data-domain-script',
      '8abad26a-eb17-40f2-ba7f-6cd61a75adf7-test'
    );
  }
  document.getElementsByTagName('head')[0].appendChild(loadFirstScript);
  document.getElementsByTagName('head')[0].appendChild(loadSecondScript);
})();
// OneTrust Cookies Consent Notice end for portal.ec.pwc.com

  /* one trust - block pendo manually */
  document.addEventListener('pendoLoaded', function (e) {
    isOneTrustAllowPendo = true;
  });

(function() {
  const pendoScript = document.createElement('script');
  pendoScript.type = 'text/plain';
  pendoScript.setAttribute('id', 'pendo-script');
  pendoScript.setAttribute('class', 'optanon-category-2');
  pendoScript.text = `
  /* pendo source */
  (function (apiKey) {
    (function (p, e, n, d, o) {
      var v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
            };
        })(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })('ea99389b-eacc-476c-597c-4b8dafd40860'); // need to update api key for nlhr
  var pendoEvent = new CustomEvent("pendoLoaded", { "detail": "Pendo has been loaded" });
  document.dispatchEvent(pendoEvent);
  `;
  document.getElementsByTagName('head')[0].appendChild(pendoScript);
})();

/**Datadog source */
